module.exports = __webpack_public_path__ + "img/data-reservoir.644938a7.svg";